// Global Enums
import {
  AdminAccessTokenStatus,
  AdminStatus,
  AdvertisementType,
  ChampionshipDocumentStatus,
  CrewmemberAccessTokenStatus,
  CrewmemberAuthType,
  CrewmemberGender,
  CrewmemberLanguage,
  CrewmemberTshirt,
  GroupType,
  RatingType,
  RegattaBoatRentStatus,
  RegattaCoursePointSide,
  RegattaCoursePointType,
  RegattaDocumentStatus,
  RegattaEntryCrewmemberGender,
  RegattaEntryCrewmemberTshirt,
  RegattaGroupRatingType,
  RegattaLogAction,
  RegattaMessageType,
  RegattaPaymentStatus,
  RegattaProtestType,
  RegattaRegistrationStatus,
  RegattaRequirementType,
  RegattaResultOverallFilter,
  RegattaResultOverallType,
  RegattaResultTableRaceType,
  RegattaResultTableType,
  RegattaStatus,
} from 'common.data';

const t = (v: string): string => v;

export type AdminAccessTokenStatusLabel = Record<AdminAccessTokenStatus, string>;

export const adminAccessTokenStatusLabel: AdminAccessTokenStatusLabel = {
  [AdminAccessTokenStatus.invalid]: t('Invalid'),
  [AdminAccessTokenStatus.valid]: t('Valid'),
};

export type AdminStatusLabel = Record<AdminStatus, string>;

export const adminStatusLabel: AdminStatusLabel = {
  [AdminStatus.confirmed]: t('Confirmed'),
  [AdminStatus.suspended]: t('Suspended'),
  [AdminStatus.unconfirmed]: t('Unconfirmed'),
};

export type AdvertisementTypeLabel = Record<AdvertisementType, string>;

export const advertisementTypeLabel: AdvertisementTypeLabel = {
  [AdvertisementType.crew]: t('Crew'),
  [AdvertisementType.crewmember]: t('Crewmember'),
};

export type ChampionshipDocumentStatusLabel = Record<ChampionshipDocumentStatus, string>;

export const championshipDocumentStatusLabel: ChampionshipDocumentStatusLabel = {
  [ChampionshipDocumentStatus.confirmed]: t('Confirmed'),
  [ChampionshipDocumentStatus.pending]: t('Pending'),
  [ChampionshipDocumentStatus.rejected]: t('Rejected'),
};

export type CrewmemberAuthTypeLabel = Record<CrewmemberAuthType, string>;

export const crewmemberAuthTypeLabel: CrewmemberAuthTypeLabel = {
  [CrewmemberAuthType.facebook]: t('Facebook'),
  [CrewmemberAuthType.google]: t('Google'),
};

export type CrewmemberAccessTokenStatusLabel = Record<CrewmemberAccessTokenStatus, string>;

export const crewmemberAccessTokenStatusLabel: CrewmemberAccessTokenStatusLabel = {
  [CrewmemberAccessTokenStatus.invalid]: t('Invalid'),
  [CrewmemberAccessTokenStatus.valid]: t('Valid'),
};

export type CrewmemberGenderLabel = Record<CrewmemberGender, string>;

export const crewmemberGenderLabel: CrewmemberGenderLabel = {
  [CrewmemberGender.female]: t('Female'),
  [CrewmemberGender.male]: t('Male'),
};

export type CrewmemberLanguageLabel = Record<CrewmemberLanguage, string>;

export const crewmemberLanguageLabel: CrewmemberLanguageLabel = {
  [CrewmemberLanguage.en]: t('English'),
};

export type CrewmemberTshirtLabel = Record<CrewmemberTshirt, string>;

export const crewmemberTshirtLabel: CrewmemberTshirtLabel = {
  [CrewmemberTshirt.l]: t('L'),
  [CrewmemberTshirt.m]: t('M'),
  [CrewmemberTshirt.s]: t('S'),
  [CrewmemberTshirt.xl]: t('XL'),
  [CrewmemberTshirt.xs]: t('XS'),
  [CrewmemberTshirt.xxl]: t('XXL'),
};

export type GroupTypeLabel = Record<GroupType, string>;

export const groupTypeLabel: GroupTypeLabel = {
  [GroupType.cruiser]: t('Cruiser'),
  [GroupType.sport]: t('Sport'),
};

export type RatingTypeLabel = Record<RatingType, string>;

export const ratingTypeLabel: RatingTypeLabel = {
  [RatingType.irc]: t('IRC'),
  [RatingType.lkrth]: t('LKRTH'),
  [RatingType.lys]: t('LYS'),
  [RatingType.monotype]: t('Monotype'),
  [RatingType.orc]: t('ORC'),
  [RatingType.vjdh]: t('VJDH'),
};

export type RegattaBoatRentStatusLabel = Record<RegattaBoatRentStatus, string>;

export const regattaBoatRentStatusLabel: RegattaBoatRentStatusLabel = {
  [RegattaBoatRentStatus.available]: t('Available'),
  [RegattaBoatRentStatus.booked]: t('Booked'),
  [RegattaBoatRentStatus.reserved]: t('Reserved'),
};

export type RegattaCoursePointSideLabel = Record<RegattaCoursePointSide, string>;

export const regattaCoursePointSideLabel: RegattaCoursePointSideLabel = {
  [RegattaCoursePointSide.port]: t('Port'),
  [RegattaCoursePointSide.starboard]: t('Starboard'),
};

export type RegattaCoursePointTypeLabel = Record<RegattaCoursePointType, string>;

export const regattaCoursePointTypeLabel: RegattaCoursePointTypeLabel = {
  [RegattaCoursePointType.default]: t('Default'),
  [RegattaCoursePointType.gate]: t('Gate'),
  [RegattaCoursePointType.independent]: t('Independent'),
  [RegattaCoursePointType.invisible]: t('Invisible'),
};

export type RegattaDocumentStatusLabel = Record<RegattaDocumentStatus, string>;

export const regattaDocumentStatusLabel: RegattaDocumentStatusLabel = {
  [RegattaDocumentStatus.confirmed]: t('Confirmed'),
  [RegattaDocumentStatus.pending]: t('Pending'),
  [RegattaDocumentStatus.rejected]: t('Rejected'),
};

export type RegattaEntryCrewmemberGenderLabel = Record<RegattaEntryCrewmemberGender, string>;

export const regattaEntryCrewmemberGenderLabel: RegattaEntryCrewmemberGenderLabel = {
  [RegattaEntryCrewmemberGender.female]: t('Female'),
  [RegattaEntryCrewmemberGender.male]: t('Male'),
};

export type RegattaEntryCrewmemberTshirtLabel = Record<RegattaEntryCrewmemberTshirt, string>;

export const regattaEntryCrewmemberTshirtLabel: RegattaEntryCrewmemberTshirtLabel = {
  [RegattaEntryCrewmemberTshirt.l]: t('L'),
  [RegattaEntryCrewmemberTshirt.m]: t('M'),
  [RegattaEntryCrewmemberTshirt.s]: t('S'),
  [RegattaEntryCrewmemberTshirt.xl]: t('XL'),
  [RegattaEntryCrewmemberTshirt.xs]: t('XS'),
  [RegattaEntryCrewmemberTshirt.xxl]: t('XXL'),
};

export type RegattaGroupRatingTypeLabel = Record<RegattaGroupRatingType, string>;

export const regattaGroupRatingTypeLabel: RegattaGroupRatingTypeLabel = {
  [RegattaGroupRatingType.irc]: t('IRC'),
  [RegattaGroupRatingType.lkrth]: t('LKRTH'),
  [RegattaGroupRatingType.lys]: t('LYS'),
  [RegattaGroupRatingType.monotype]: t('Monotype'),
  [RegattaGroupRatingType.orc]: t('ORC'),
  [RegattaGroupRatingType.vjdh]: t('VJDH'),
};

export type RegattaPaymentStatusLabel = Record<RegattaPaymentStatus, string>;

export const regattaPaymentStatusLabel: RegattaPaymentStatusLabel = {
  [RegattaPaymentStatus.fulfilled]: t('Fulfilled'),
  [RegattaPaymentStatus.intent]: t('Intent'),
  [RegattaPaymentStatus.pending]: t('Pending'),
};

export type RegattaProtestTypeLabel = Record<RegattaProtestType, string>;

export const regattaProtestTypeLabel: RegattaProtestTypeLabel = {
  [RegattaProtestType.type1BoatToBoat]: t('Protest by boat against boat'),
  [RegattaProtestType.type2RcToBoat]: t('Protest by race committee against boat'),
  [RegattaProtestType.type3PcToBoat]: t('Protest by protest committee against boat'),
  [RegattaProtestType.type4RcOrBoatRequestForRedress]: t('Request for redress by boat or race committee'),
  [RegattaProtestType.type5PcConsiderationOfRedress]: t('Consideration of redress by protest committee'),
  [RegattaProtestType.type6RcOrBoatRequestForReopen]: t('Request by boat or race committee to reopen hearing'),
  [RegattaProtestType.type7PcConsiderationOfReopen]: t('Consideration of reopening by protest committee'),
};

export type RegattaMessageTypeLabel = Record<RegattaMessageType, string>;

export const regattaMessageTypeLabel: RegattaMessageTypeLabel = {
  [RegattaMessageType.organizingAuthority]: t('Organizing authority'),
  [RegattaMessageType.protestCommittee]: t('Protest committee'),
  [RegattaMessageType.raceCommittee]: t('Race committee'),
  [RegattaMessageType.technicalCommittee]: t('Technical committee'),
};

export type RegattaRegistrationStatusLabel = Record<RegattaRegistrationStatus, string>;

export const regattaRegistrationStatusLabel: RegattaRegistrationStatusLabel = {
  [RegattaRegistrationStatus.ended]: t('Ended'),
  [RegattaRegistrationStatus.off]: t('Off'),
  [RegattaRegistrationStatus.ongoing]: t('Ongoing'),
  [RegattaRegistrationStatus.upcoming]: t('Upcoming'),
};

export type RegattaRequirementTypeLabel = Record<RegattaRequirementType, string>;

export const regattaRequirementTypeLabel: RegattaRequirementTypeLabel = {
  // [RegattaRequirementType.selectUnique]: t('Dropdown value (unique)'),
  [RegattaRequirementType.boolean]: t('Yes / No'),
  [RegattaRequirementType.file]: t('Attached file'),
  [RegattaRequirementType.fileSource]: t('Attached file + Source file'),
  [RegattaRequirementType.select]: t('Dropdown value'),
  [RegattaRequirementType.value]: t('Free text value'),
  [RegattaRequirementType.valueUnique]: t('Free text value (unique)'),
};

export type RegattaResultOverallFilterLabel = Record<RegattaResultOverallFilter, string>;

export const regattaResultOverallFilterLabel: RegattaResultOverallFilterLabel = {
  [RegattaResultOverallFilter.adultCrew]: t('Adult crew'),
  [RegattaResultOverallFilter.adultSkipper]: t('Adult skipper'),
  [RegattaResultOverallFilter.femaleCrew]: t('All female crew'),
  [RegattaResultOverallFilter.femaleSkipper]: t('Female skipper'),
  [RegattaResultOverallFilter.maleCrew]: t('All male crew'),
  [RegattaResultOverallFilter.maleSkipper]: t('Male skipper'),
  [RegattaResultOverallFilter.u12]: t('U12'),
  [RegattaResultOverallFilter.u13]: t('U13'),
  [RegattaResultOverallFilter.u14]: t('U14'),
  [RegattaResultOverallFilter.u15]: t('U15'),
  [RegattaResultOverallFilter.u16]: t('U16'),
  [RegattaResultOverallFilter.u18]: t('U18'),
  [RegattaResultOverallFilter.u19]: t('U19'),
  [RegattaResultOverallFilter.u21]: t('U21'),
};

export type RegattaResultOverallTypeLabel = Record<RegattaResultOverallType, string>;

export const regattaResultOverallTypeLabel: RegattaResultOverallTypeLabel = {
  [RegattaResultOverallType.ct]: t('CT'),
  [RegattaResultOverallType.et]: t('ET'),
  [RegattaResultOverallType.points]: t('Points'),
};

export type RegattaResultTableTypeLabel = Record<RegattaResultTableType, string>;

export const regattaResultTableTypeLabel: RegattaResultTableTypeLabel = {
  [RegattaResultTableType.board]: t('Board'),
  [RegattaResultTableType.boat]: t('Boat'),
};

export type RegattaResultTableRaceTypeLabel = Record<RegattaResultTableRaceType, string>;

export const regattaResultTableRaceTypeLabel: RegattaResultTableRaceTypeLabel = {
  [RegattaResultTableRaceType.irc]: t('IRC'),
  [RegattaResultTableRaceType.lkrth]: t('LKRTH'),
  [RegattaResultTableRaceType.lys]: t('LYS'),
  [RegattaResultTableRaceType.monotype]: t('Monotype'),
  [RegattaResultTableRaceType.orcTnTodHighCostalLongDistance]: t('ORC Triple Number High ToD | Costal / Long distance'),
  [RegattaResultTableRaceType.orcTnTodHighWindwardLeeward]: t('ORC Triple Number High ToD | Windward / Leeward'),
  [RegattaResultTableRaceType.orcTnTodLowCostalLongDistance]: t('ORC Triple Number Low ToD | Costal / Long distance'),
  [RegattaResultTableRaceType.orcTnTodLowWindwardLeeward]: t('ORC Triple Number Low ToD | Windward / Leeward'),
  [RegattaResultTableRaceType.orcTnTodMediumCostalLongDistance]: t('ORC Triple Number Medium ToD | Costal / Long distance'),
  [RegattaResultTableRaceType.orcTnTodMediumWindwardLeeward]: t('ORC Triple Number Medium ToD | Windward / Leeward'),
  [RegattaResultTableRaceType.orcTnTotHighCostalLongDistance]: t('ORC Triple Number High ToT | Costal / Long distance'),
  [RegattaResultTableRaceType.orcTnTotHighWindwardLeeward]: t('ORC Triple Number High ToT | Windward / Leeward'),
  [RegattaResultTableRaceType.orcTnTotLowCostalLongDistance]: t('ORC Triple Number Low ToT | Costal / Long distance'),
  [RegattaResultTableRaceType.orcTnTotLowWindwardLeeward]: t('ORC Triple Number Low ToT | Windward / Leeward'),
  [RegattaResultTableRaceType.orcTnTotMediumCostalLongDistance]: t('ORC Triple Number Medium ToT | Costal / Long distance'),
  [RegattaResultTableRaceType.orcTnTotMediumWindwardLeeward]: t('ORC Triple Number Medium ToT | Windward / Leeward'),
  [RegattaResultTableRaceType.orcTodCostalLongDistance]: t('ORC ToD | Costal / Long distance'),
  [RegattaResultTableRaceType.orcTodWindwardLeeward]: t('ORC ToD | Windward / Leeward'),
  [RegattaResultTableRaceType.orcTotCostalLongDistance]: t('ORC ToT | Costal / Long distance'),
  [RegattaResultTableRaceType.orcTotWindwardLeeward]: t('ORC ToT | Windward / Leeward'),
  [RegattaResultTableRaceType.roundings]: t('Roundings'),
  [RegattaResultTableRaceType.vjdh]: t('VJDH'),
};

export type RegattaStatusLabel = Record<RegattaStatus, string>;

export const regattaStatusLabel: RegattaStatusLabel = {
  [RegattaStatus.canceled]: t('Canceled'),
  [RegattaStatus.ended]: t('Ended'),
  [RegattaStatus.new]: t('New'),
  [RegattaStatus.ongoing]: t('Ongoing'),
  [RegattaStatus.upcoming]: t('Upcoming'),
};

export type RegattaLogActionLabel = Record<RegattaLogAction, string>;

export const regattaLogActionLabel: RegattaLogActionLabel = {
  [RegattaLogAction.created]: t('Created'),
  [RegattaLogAction.deleted]: t('Deleted'),
  [RegattaLogAction.updated]: t('Updated'),
};
